import { SpecificPriceRuleCreateFields } from './types'
import { roundingDividers } from '@teinor/erp/prices'
import { decimalsDict } from '@teinor/erp/types/company/config/parameter'
import { useMemo } from 'react'
import ModalCreateEdit from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { CustomSelectDropDownSortedNumbers } from '../../../../../../../forms/CustomSelect/DropDown'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { addDictionaryExtraLine, dictionaryComplexFromSimpleDict } from '../../../../../../../utils/globals/dictionary'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { getPriceZoneGroups, getCustomerGroups, getActiveCurrenciesDictionary } from '../../../../../../../utils/reducers/getters'
import useCustomerTypesDict from '../../../../../../../utils/hooks/customer/useCustomerTypesDict'
import { emptyExtraLineFirstSortFunction } from '../../../../../../../forms/CustomSelect/functions'

interface ModalCESPRuleProps extends ModalEditComponentProps { }

const ModalCESPRule: React.FC<ModalCESPRuleProps> = ({ userPermissions, allRowData, ...rest }) => {
    const priceZoneGroupsDict = useMemo(() => addDictionaryExtraLine(getPriceZoneGroups() || {}), [])
    const roundingDict = dictionaryComplexFromSimpleDict(roundingDividers as any)
    const decimalsDictParsed = dictionaryComplexFromSimpleDict(decimalsDict as any)
    const { t } = useTwinTranslation()
    const { dictCustomerTypeShort } = useCustomerTypesDict()
    const dictCustomerTypeShortMemorized = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(dictCustomerTypeShort || {}))), [dictCustomerTypeShort])
    const fields: FormRender<SpecificPriceRuleCreateFields> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'CurrencyId',
                    label: t('currency', 'Moneda'),
                    component: 'CustomSelect',
                    items: getActiveCurrenciesDictionary(),
                    required: true
                },
                {
                    name: 'PriceZoneGroupId',
                    label: t('priceZoneGroup', 'Zona de precio'),
                    component: 'CustomSelect',
                    items: priceZoneGroupsDict
                },
                {
                    name: 'formula',
                    label: t('formula', 'Fórmula'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'decimals',
                    label: t('decimals', 'Decimales'),
                    component: 'CustomSelect',
                    required: true,
                    items: decimalsDictParsed
                },
                {
                    name: 'rounding',
                    label: t('rounding', 'Redondeo'),
                    component: 'CustomSelect',
                    items: addDictionaryExtraLine(roundingDict),
                    sortItems: true,
                    DropDownComponent: CustomSelectDropDownSortedNumbers,
                },
                {
                    name: 'customerType',
                    label: t('type', 'Tipo'),
                    component: 'CustomSelect',
                    items: dictCustomerTypeShortMemorized,
                    value: allRowData?.customerType,
                    sortFunction: emptyExtraLineFirstSortFunction
                },
                {
                    name: 'with_vat',
                    label: t('priceWithVatShort', 'Precio con imp.'),
                    component: 'CheckboxMargin',
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ]
        },
        {
            cols: 1,
            className: 'mt-20',
            elements: [
                {
                    name: 'customerGroupsParsed',
                    subtitles: {
                        subtitleOptions: t('customerGroups', 'Grupos de cliente'),
                        subtitleSelectedOptions: t('customerGroupsSelected', 'Grupos de cliente seleccionados')
                    },
                    component: 'MultipleCheckboxSelector',
                    items: getCustomerGroups()?.dictionary || {},
                    defaultValue: allRowData?.SpecificPriceCustomersRelsParsed || []
                },
            ]
        }
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<ModalCreateEdit fields={parsedFields} url={'/api/app/product/specificPrice/updateSpecificPriceRule'} translations={{ title: t('editSpecificPriceRule', 'Editar grupo de tarifa'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }

    return (<ModalCreateEdit fields={fields} url={'/api/app/product/specificPrice/createSpecificPriceRule'} translations={{
        title: t('createSpecificPriceRule', 'Crear grupo de tarifa'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCESPRule;